// extracted by mini-css-extract-plugin
export default {"table":"OrderAmountDistribution_table__0naXA","distributionTable":"OrderAmountDistribution_distributionTable__kkTMO"};